var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_vm._m(0),_c('strong',[_c('a',{attrs:{"href":"#"}},[_vm._v("KUS - VCARD")]),_vm._v(" "+_vm._s(new Date().getFullYear()))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-right d-none d-sm-block"},[_c('b',[_vm._v("Version")]),_vm._v(" 1.0.0 ")])
}]

export { render, staticRenderFns }